(function () {
  'use strict';

  if (window.__hidrPriceBoxOptimizedV1) return;
  window.__hidrPriceBoxOptimizedV1 = true;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return (Number(cents || 0) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function addToCart(form) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    var formData = new FormData(form);

    var variantInput = form.querySelector('[name="id"], [data-hidr-form-variant-id]');
    var quantityInput = form.querySelector('[name="quantity"], [data-hidr-form-quantity]');

    var variantId = variantInput ? String(variantInput.value || '').trim() : '';
    var quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;

    if (!quantity || Number.isNaN(quantity) || quantity < 1) {
      quantity = 1;
    }

    if (!variantId) {
      reject({
        status: 0,
        message: 'Nenhuma variante selecionada para adicionar ao carrinho'
      });
      return;
    }

    formData.set('id', variantId);
    formData.set('quantity', String(quantity));

    xhr.open('POST', '/cart/add.js', true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;

      var data = null;

      try {
        data = xhr.responseText ? JSON.parse(xhr.responseText) : null;
      } catch (error) {
        data = xhr.responseText;
      }

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(data);
      } else {
        reject(data || {
          status: xhr.status,
          message: 'Erro ao adicionar ao carrinho'
        });
      }
    };

    xhr.onerror = function () {
      reject({
        status: xhr.status || 0,
        message: 'Erro de rede'
      });
    };

    xhr.send(formData);
  });
}

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function openCartUi() {
  window.requestAnimationFrame(function () {
    var attempts = 0;

    var interval = window.setInterval(function () {
      attempts += 1;

      if (typeof window.monster_refresh === 'function') {
        window.monster_refresh(false);
      }

      if (typeof window.openCart === 'function') {
        window.openCart();
        window.clearInterval(interval);
        return;
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        window.clearInterval(interval);
        return;
      }

      if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
        window.clearInterval(interval);
        return;
      }

      if (attempts >= 10) {
        window.clearInterval(interval);
      }
    }, 300);
  });
}

  function dispatchCartEvents(item, cart, includeLegacyEvents) {
    var detail = {
      item: item || null,
      cart: cart || null,
      source: 'hidr-price-box'
    };

    var events = [
      'hidr:cart:add',
      'cart:refresh',
      'cart:updated'
    ];

    if (includeLegacyEvents) {
      events.push('ajaxProduct:added');
      events.push('product:added');
    }

    events.forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: detail
      }));
    });

    window.dispatchEvent(new CustomEvent('cart:updated', {
      detail: detail
    }));

    window.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: detail
    }));
  }

  function notifyCartImmediately(item) {
    dispatchCartEvents(item, null, true);
    openCartUi();
  }

  function syncCartInBackground(item) {
    window.setTimeout(function () {
      getCart().then(function (cart) {
        if (!cart) return;

        var detail = {
          item: item || null,
          cart: cart,
          source: 'hidr-price-box'
        };

        document.dispatchEvent(new CustomEvent('hidr:cart:sync', {
          bubbles: true,
          detail: detail
        }));

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: detail
        }));

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: detail
        }));

        window.dispatchEvent(new CustomEvent('cart:updated', {
          detail: detail
        }));

        window.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: detail
        }));
      });
    }, 80);
  }

  function setupHidrPriceBox(scope) {
    var roots = Array.prototype.slice.call(
      (scope || document).querySelectorAll('[data-hidr-price-root]:not([data-hidr-price-ready="true"])')
    );

    if (!roots.length) return;

    roots.forEach(function (root) {
      root.dataset.hidrPriceReady = 'true';

      var isProtocol = root.dataset.hidrIsProtocol === 'true';
      var form = root.querySelector('[data-hidr-price-form]');
      var formVariantInput = root.querySelector('[data-hidr-form-variant-id]');
      var formQuantityInput = root.querySelector('[data-hidr-form-quantity]');
      var submitButton = root.querySelector('.hidr-price-box__submit');
      var submitText = root.querySelector('[data-hidr-submit-text]');
      var shippingStrip = root.querySelector('[data-hidr-shipping-strip]');
      var shippingText = root.querySelector('[data-hidr-shipping-text]');
      var freeShippingThreshold = parseInt(root.dataset.freeShippingThreshold || '16900', 10);

      if (!form || !submitButton || !formVariantInput || !formQuantityInput) return;

      function updateShipping(totalPrice) {
        if (!shippingStrip || !shippingText) return;

        if (totalPrice >= freeShippingThreshold) {
          shippingStrip.classList.add('is-free-shipping');
          shippingText.innerHTML = '<strong>Parabéns!</strong> Você ganhou frete grátis';
        } else {
          shippingStrip.classList.remove('is-free-shipping');
          shippingText.innerHTML = '<strong>Frete grátis!</strong> a partir de R$ 169,00!';
        }
      }

      function setButtonLoading(isLoading, text) {
        submitButton.disabled = Boolean(isLoading);
        submitButton.classList.toggle('is-loading', Boolean(isLoading));

        if (isLoading) {
          submitButton.setAttribute('aria-busy', 'true');
        } else {
          submitButton.removeAttribute('aria-busy');
        }

        if (submitText && text) {
          submitText.textContent = text;
        }
      }

      function getQuantityInput() {
        return root.querySelector('[data-hidr-qty-input]');
      }

      function getQuantity() {
        var qtyInput = getQuantityInput();
        var quantity = parseInt(qtyInput ? qtyInput.value || '1' : '1', 10);

        if (Number.isNaN(quantity) || quantity < 1) {
          quantity = 1;
        }

        return quantity;
      }

      function syncProtocolVariant() {
        var protocolRoot = root.querySelector('[data-hidr-protocol-bundle-root]');
        var selectedRadio = protocolRoot
          ? protocolRoot.querySelector('input[type="radio"]:checked')
          : null;

        if (!selectedRadio && protocolRoot) {
          selectedRadio = protocolRoot.querySelector('input[type="radio"]');
        }

        if (!selectedRadio) return;

        selectedRadio.checked = true;

        var selectedVariantId = selectedRadio.value;
        var selectedPrice = parseInt(selectedRadio.dataset.variantPrice || '0', 10);
        var selectedAvailable = selectedRadio.dataset.variantAvailable === 'true';

        root.querySelectorAll('[data-bundle-card]').forEach(function (card) {
          var input = card.querySelector('input[type="radio"]');
          card.classList.toggle('is-active', input === selectedRadio);
        });

        formVariantInput.value = selectedVariantId;
        formQuantityInput.value = '1';

        updateShipping(selectedPrice);

        if (selectedAvailable) {
          submitButton.disabled = false;
          submitButton.setAttribute('aria-disabled', 'false');

          if (submitText) {
            submitText.textContent = 'COMPRAR';
          }
        } else {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-disabled', 'true');

          if (submitText) {
            submitText.textContent = 'Indisponível';
          }
        }
      }

      function setupProtocol() {
        var protocolRoot = root.querySelector('[data-hidr-protocol-bundle-root]');
        var radios = protocolRoot
          ? Array.prototype.slice.call(protocolRoot.querySelectorAll('input[type="radio"]'))
          : [];

        radios.forEach(function (radio) {
          radio.addEventListener('change', syncProtocolVariant);
        });

        syncProtocolVariant();
      }

      function setupNormalProduct() {
        var variantsJson = root.querySelector('[data-hidr-variants-json]');
        var bundleVariantJson = root.querySelector('[data-hidr-bundle-variant-json]');
        var variants = [];
        var bundleVariant = null;

        try {
          variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
        } catch (error) {
          variants = [];
        }

        try {
          bundleVariant = bundleVariantJson ? JSON.parse(bundleVariantJson.textContent) : null;
        } catch (error) {
          bundleVariant = null;
        }

        var bundleComparePrice = parseInt(root.dataset.hidrBundleComparePrice || '', 10);
        var bundleCheckbox = root.querySelector('[data-hidr-bundle-checkbox]');
        var bundleCard = root.querySelector('[data-hidr-bundle-card]');
        var currentPriceEl = root.querySelector('[data-hidr-current-price]');
        var comparePriceEl = root.querySelector('[data-hidr-compare-price]');
        var savingPriceEl = root.querySelector('[data-hidr-saving-price]');
        var promoLineEl = root.querySelector('[data-hidr-promo-line]');
        var installmentsEl = root.querySelector('[data-hidr-installments]');
        var installmentsCountEl = root.querySelector('[data-hidr-installments-count]');
        var installmentsValueEl = root.querySelector('[data-hidr-installments-value]');
        var pixTextEl = root.querySelector('[data-hidr-pix-price]');
        var qtyInput = root.querySelector('[data-hidr-qty-input]');
        var qtyMinus = root.querySelector('[data-hidr-qty-minus]');
        var qtyPlus = root.querySelector('[data-hidr-qty-plus]');

        var baseSelectedVariant =
          variants.find(function (item) {
            return String(item.id) === String(root.dataset.baseVariantId);
          }) ||
          variants.find(function (item) {
            return String(item.id) === String(formVariantInput.value);
          }) ||
          variants[0] ||
          null;

        function isBundleSelected() {
          return Boolean(bundleCheckbox && bundleCheckbox.checked && bundleVariant);
        }

        function getActiveVariant() {
          return isBundleSelected() ? bundleVariant : baseSelectedVariant;
        }

        function updateBundleCard() {
          if (!bundleCard) return;
          bundleCard.classList.toggle('is-active', isBundleSelected());
        }

        function getComparePrice(variant) {
          if (!variant) return null;

          if (
            bundleVariant &&
            String(variant.id) === String(bundleVariant.id) &&
            !Number.isNaN(bundleComparePrice) &&
            bundleComparePrice > variant.price
          ) {
            return bundleComparePrice;
          }

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            return variant.compare_at_price;
          }

          return null;
        }

        function updateInstallments(totalPrice) {
          var minInstallment = 5000;
          var maxInstallments = Math.min(12, Math.floor(totalPrice / minInstallment));

          if (!installmentsEl || !installmentsCountEl || !installmentsValueEl) return;

          if (maxInstallments >= 2) {
            installmentsCountEl.textContent = maxInstallments + 'x';
            installmentsValueEl.textContent = formatMoney(Math.round(totalPrice / maxInstallments));
            installmentsEl.classList.remove('is-hidden');
          } else {
            installmentsEl.classList.add('is-hidden');
          }
        }

        function renderPrice() {
          var selectedVariant = getActiveVariant();

          if (!selectedVariant || !currentPriceEl) return;

          var quantity = getQuantity();
          var totalPrice = selectedVariant.price * quantity;
          var comparePrice = getComparePrice(selectedVariant);
          var totalComparePrice = comparePrice ? comparePrice * quantity : null;

          currentPriceEl.textContent = formatMoney(totalPrice);

          formVariantInput.value = selectedVariant.id;
          formQuantityInput.value = quantity;

          if (totalComparePrice && totalComparePrice > totalPrice) {
            if (comparePriceEl) comparePriceEl.textContent = formatMoney(totalComparePrice);
            if (savingPriceEl) savingPriceEl.textContent = '- ' + formatMoney(totalComparePrice - totalPrice);
            if (promoLineEl) promoLineEl.classList.remove('is-hidden');
          } else {
            if (comparePriceEl) comparePriceEl.textContent = '';
            if (savingPriceEl) savingPriceEl.textContent = '';
            if (promoLineEl) promoLineEl.classList.add('is-hidden');
          }

          if (pixTextEl) {
            pixTextEl.textContent = formatMoney(Math.round(totalPrice * 0.97)) + ' no PIX';
          }

          updateInstallments(totalPrice);
          updateShipping(totalPrice);
          updateBundleCard();

          if (selectedVariant.available) {
            submitButton.disabled = false;
            submitButton.setAttribute('aria-disabled', 'false');

            if (submitText) {
              submitText.textContent = 'COMPRAR';
            }
          } else {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', 'true');

            if (submitText) {
              submitText.textContent = 'Indisponível';
            }
          }
        }

        function syncQuantity(value) {
          var quantity = parseInt(value || '1', 10);

          if (Number.isNaN(quantity) || quantity < 1) {
            quantity = 1;
          }

          if (qtyInput) qtyInput.value = quantity;
          formQuantityInput.value = quantity;

          renderPrice();
        }

        if (qtyMinus) {
          qtyMinus.addEventListener('click', function () {
            syncQuantity(getQuantity() - 1);
          });
        }

        if (qtyPlus) {
          qtyPlus.addEventListener('click', function () {
            syncQuantity(getQuantity() + 1);
          });
        }

        if (qtyInput) {
          qtyInput.addEventListener('input', function () {
            syncQuantity(this.value);
          });

          qtyInput.addEventListener('change', function () {
            syncQuantity(this.value);
          });
        }

        if (bundleCheckbox) {
          bundleCheckbox.addEventListener('change', renderPrice);
        }

        document.addEventListener('change', function (event) {
          var target = event.target;

          if (!target || target.name !== 'id') return;

          var variant = variants.find(function (item) {
            return String(item.id) === String(target.value);
          });

          if (!variant) return;

          baseSelectedVariant = variant;
          renderPrice();
        });

        document.addEventListener('variant:change', function (event) {
          if (event.detail && event.detail.variant) {
            baseSelectedVariant = event.detail.variant;
            renderPrice();
          }
        });

        document.addEventListener('product:variant-change', function (event) {
          if (event.detail && event.detail.variant) {
            baseSelectedVariant = event.detail.variant;
            renderPrice();
          }
        });

        root.__hidrRenderPrice = renderPrice;

        syncQuantity(1);
      }

      function syncBeforeAddToCart() {
        if (isProtocol) {
          syncProtocolVariant();
          return;
        }

        if (typeof root.__hidrRenderPrice === 'function') {
          root.__hidrRenderPrice();
        }
      }

      function handleSubmit(event) {
        if (event) {
          event.preventDefault();
        }

        if (form.dataset.hidrSubmitting === 'true') return;

        syncBeforeAddToCart();

        if (!formVariantInput.value) {
          console.error('[Hidracce] Nenhuma variante selecionada para adicionar ao carrinho.');
          return;
        }

        form.dataset.hidrSubmitting = 'true';
        setButtonLoading(true, 'ADICIONANDO...');

        addToCart(form)
          .then(function (item) {
            if (submitText) {
              submitText.textContent = 'ADICIONADO';
            }

            notifyCartImmediately(item);
            syncCartInBackground(item);

            window.setTimeout(function () {
              form.dataset.hidrSubmitting = 'false';
              setButtonLoading(false, 'COMPRAR');

              syncBeforeAddToCart();
            }, 420);
          })
          .catch(function (error) {
            console.error('[Hidracce] Erro ao adicionar ao carrinho:', error);

            form.dataset.hidrSubmitting = 'false';
            setButtonLoading(false, 'TENTAR NOVAMENTE');
          });
      }

      if (isProtocol) {
        setupProtocol();
      } else {
        setupNormalProduct();
      }

      submitButton.addEventListener('click', function (event) {
        if (
          submitButton.disabled ||
          submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          event.preventDefault();
          return;
        }

        handleSubmit(event);
      });

      form.addEventListener('submit', handleSubmit);
    });
  }

  function boot() {
    setupHidrPriceBox(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupHidrPriceBox(event.target);
  });
})();